import { Division, EmptyState, Heading, Icons, Paragraph, Spin } from "@ir/ui";
import { useMasterDataBrand } from "./MasterDataBrandContext";

export const MasterDataBrandHomePage = () => {
  const {
    brand,
    organization,
    isBrandSelected,
    isLookupLoading,
    organizationKey,
    brandKey,
  } = useMasterDataBrand();

  if (isLookupLoading && organizationKey && brandKey) {
    return (
      <Division className="master-data-brand-home">
        <Spin tip="Loading brand..." />
      </Division>
    );
  }

  if (!isBrandSelected || !brand || !organization) {
    return null;
  }

  const brandLabel = brand.brandDisplayName ?? brand.brandName;
  const orgLabel =
    organization.organizationDisplayName ?? organization.organizationName;

  return (
    <Division className="master-data-brand-home">
      <Heading level={6} className="text-grey-700 font-bold m-0 mb-1">
        {brandLabel}
      </Heading>
      <Paragraph className="text-grey-500 m-0 mb-3">
        Brand in {orgLabel}
      </Paragraph>
      <EmptyState
        icon={Icons.List}
        title="Select a Master Data category"
        description="Use the left navigation to open Organization, Trading Partners, Product Catalog, and other foundational data for this brand."
      />
    </Division>
  );
};
